/**
 * Where to go after sign-in when the doctor opened a signed-in page while signed out (a link to a
 * request, the corrections page, the Qi Card return …). Both designs: the protected-route guards
 * remember the page, the OTP screens take it after a successful sign-in. The step redirect still
 * applies on the target page, so blocking steps (an incomplete profile) win over the link.
 *
 * Only a page opened by a tab that has not been signed in since it loaded is remembered: after a
 * logout (or an expired session) the next sign-in may be another doctor, who must not be sent to
 * the previous doctor's page.
 */
export const POST_LOGIN_PATH_KEY = "post_login_path";

const NOT_RETURNABLE = ["/", "/login", "/confirm_otp", "/scan_id", "/qr_manual_fallback", "/qr_phone_entry"];

let signedInThisLoad = false;

export function noteSignedIn(): void {
  signedInThisLoad = true;
}

export function isReturnablePath(path: string | null | undefined): path is string {
  if (!path || !path.startsWith("/") || path.startsWith("//")) return false;
  const pathname = path.split(/[?#]/)[0];
  return !NOT_RETURNABLE.includes(pathname);
}

export function rememberPostLoginPath(path: string): void {
  if (signedInThisLoad || !isReturnablePath(path)) return;
  try {
    sessionStorage.setItem(POST_LOGIN_PATH_KEY, path);
  } catch {
    /* storage blocked — the doctor simply lands on the default page */
  }
}

/** The remembered page (once), or null. */
export function takePostLoginPath(): string | null {
  try {
    const path = sessionStorage.getItem(POST_LOGIN_PATH_KEY);
    sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
    return isReturnablePath(path) ? path : null;
  } catch {
    return null;
  }
}
